import type {AreaDeAcceso} from '@cnc/contracts';
import type {ReactNode} from 'react';
import {Link, Navigate} from 'react-router';
import {tr} from '../i18n/idioma';
import {primeraRutaDe, ve} from './areas';
import {ContextoDeArea, useUsuario} from './sesion-contexto';

// Envuelve una pantalla con su seccion o pestana: si la persona no la ve, la
// lleva a otra pestana de la misma seccion que si vea, o le dice que no tiene
// acceso. Adentro, los botones de editar siguen el nivel de esa area.
export function ConArea({area, children}: {area: AreaDeAcceso | AreaDeAcceso[]; children: ReactNode}) {
  const usuario = useUsuario();
  const areas = Array.isArray(area) ? area : [area];
  if (!areas.some(a => ve(usuario, a))) {
    const otra = primeraRutaDe(usuario, areas[0]!.split('.')[0]!);
    if (otra) return <Navigate to={otra} replace />;
    return <SinAcceso />;
  }
  return <ContextoDeArea.Provider value={areas}>{children}</ContextoDeArea.Provider>;
}

// Un pedazo de una pantalla que pertenece a otra pestana (secciones del
// detalle de la exportacion): no se muestra si la persona no la ve.
export function SiVe({area, children}: {area: AreaDeAcceso | AreaDeAcceso[]; children: ReactNode}) {
  const usuario = useUsuario();
  const areas = Array.isArray(area) ? area : [area];
  if (!areas.some(a => ve(usuario, a))) return null;
  return <ContextoDeArea.Provider value={areas}>{children}</ContextoDeArea.Provider>;
}

export function SinAcceso() {
  return (
    <section className="max-w-xl space-y-3" data-prueba="sin-acceso">
      <h1 className="text-2xl font-semibold text-verde-oscuro">{tr('Sin acceso', 'No access')}</h1>
      <p className="text-sm text-apagado">
        {tr(
          'Esta sección no está entre las que te asignaron. Si la necesitas, pídesela a un administrador.',
          'This section is not among the ones assigned to you. If you need it, ask an administrator.',
        )}
      </p>
      <Link to="/" className="text-sm text-verde hover:underline">
        {tr('← Volver al inicio', '← Back to home')}
      </Link>
    </section>
  );
}
